import React, { useState } from "react";
import "./form.css";
import BirthImage1 from "../../../Assets/Images/Birth_Image1.jpeg";
import BirthImage2 from "../../../Assets/Images/top-bg.png";
import BirthImage3 from "../../../Assets/Images/center-bg.png";
import BirthImage4 from "../../../Assets/Images/rect.png";
import validations from "../../../Config/validations";
import Swal from "sweetalert2";
const QuoteRequestForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const missingFields = validations(
      {
        name: "Name",
        email: "Emaill",
        phone: "Phone",
        comments: "Comments",
      },
      formData,
    );
    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: `Missing Fields`,
        text: `Please enter: ${missingFields.join(", ")}`,
        confirmButtonColor: "#B79527",
      });
      return;
    }
    // console.log("Form submitted:", formData);
    // Typically, send the data to your backend here.
  };

  return (
    <div className="quote-form-container">
      <div className="quote-form-gallery">
        <div className="gallery-item layout-1">
          <img src={BirthImage2} alt="Birth" />
        </div>
        <div className="gallery-item layout-2">
          <img src={BirthImage1} alt="Birth" />
        </div>
        <div className="gallery-item layout-3">
          <img src={BirthImage3} alt="Birth" />
        </div>
        <div className="gallery-item layout-4">
          <img src={BirthImage4} alt="Birth" />
        </div>
      </div>

      <iframe
        src="https://api.leadconnectorhq.com/widget/form/IDjOnD8yqKNrjmNSENJ9"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          borderRadius: "3px",
        }}
        id="inline-IDjOnD8yqKNrjmNSENJ9"
        data-layout="{'id':'INLINE'}"
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="dream party"
        data-height="504"
        data-layout-iframe-id="inline-IDjOnD8yqKNrjmNSENJ9"
        data-form-id="IDjOnD8yqKNrjmNSENJ9"
        title="dream party"
      ></iframe>
      {/*
      <form className="quote-form" onSubmit={handleSubmit}>
        <div className="form-field full-width">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <div className="form-field half-width">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-field half-width">
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-field full-width">
          <textarea
            name="comments"
            placeholder="Comments & Requests"
            value={formData.comments}
            onChange={handleChange}
            rows={4}
          ></textarea>
        </div>

        <button type="submit" className="submit-button">
          Request a Quote
        </button>
      </form> */}
    </div>
  );
};

export default QuoteRequestForm;
